<template>
  <icon-wrapper
    name="megaphone-spotify"
    :tag="tag"
    :block-name="blockName"
    :class-name="className"
    :modifiers="modifiers"
  >
    <!-- eslint-disable-next-line -->
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path d="M5.7134 11.7398V7.66487C5.7134 7.07387 5.76729 6.4478 5.58408 5.87839C5.39411 5.30008 5.01826 4.80107 4.51523 4.45932C4.01221 4.11757 3.41034 3.95231 2.80364 3.98937C2.19751 4.03772 1.62444 4.28586 1.17403 4.69502C0.72362 5.10417 0.421248 5.65127 0.314181 6.2508C0.279179 6.48746 0.265652 6.72682 0.273768 6.96593V11.4591C0.267947 11.6789 0.276949 11.8989 0.30071 12.1176C0.392171 12.7238 0.682521 13.2823 1.12596 13.705C1.56941 14.1276 2.14071 14.3904 2.74976 14.4518C3.1247 14.4855 3.50252 14.4408 3.85933 14.3206C4.21615 14.2005 4.5442 14.0075 4.82274 13.7539C5.10128 13.5003 5.32425 13.1915 5.47756 12.8471C5.63087 12.5028 5.71117 12.1303 5.7134 11.7532V11.7398ZM12.8908 13.8474V4.61275C12.8893 3.94794 12.6452 3.30661 12.2046 2.80946C11.7639 2.31231 11.157 1.99362 10.4982 1.91337C9.83927 1.83311 9.17383 1.99683 8.62705 2.3737C8.08028 2.75058 7.68987 3.31462 7.52931 3.95969C7.46434 4.27281 7.4381 4.59275 7.45118 4.91229V13.7988C7.44906 14.4072 7.65044 14.9988 8.02318 15.4792C8.39592 15.9596 8.91856 16.3011 9.50769 16.4492C10.0968 16.5974 10.7185 16.5436 11.2736 16.2965C11.8287 16.0494 12.2852 15.6233 12.5702 15.086C12.7721 14.6996 12.8775 14.27 12.8773 13.8339L12.8908 13.8474ZM20.0521 15.7229V3.03946C20.0727 2.60484 20.0124 2.17016 19.8742 1.75763C19.6739 1.22838 19.3139 0.774809 18.8443 0.460005C18.3747 0.1452 17.8188 -0.0151927 17.2539 0.00113342C16.689 0.0174595 16.1433 0.209693 15.6926 0.551098C15.2419 0.892504 14.9086 1.36611 14.739 1.90605C14.6366 2.28661 14.5939 2.68083 14.6124 3.07455V15.1697C14.6124 15.4018 14.6124 15.6392 14.6124 15.8713C14.6379 16.4433 14.8427 16.9927 15.1978 17.4414C15.5529 17.8901 16.0402 18.2153 16.5904 18.3707C17.1405 18.5261 17.7256 18.5038 18.2625 18.307C18.7993 18.1102 19.2605 17.749 19.5806 17.2746C19.8962 16.8199 20.0654 16.2794 20.0655 15.7256" /></svg>
  </icon-wrapper>
</template>

<script>
import IconWrapper from './_wrapper.vue';

export default {
  components: { IconWrapper },
  props: {
    blockName: {
      type: String,
      default: 'marko-web-icon',
    },
    className: {
      type: String,
      default: null,
    },
    modifiers: {
      type: Array,
      default: () => ([]),
    },
    tag: {
      type: String,
      default: 'span',
    },
  },
};
</script>
